type AvatarColorPair = Readonly<{ bg: string; text: string }>;

/**
 * 7 deterministic color pairs for avatar fallbacks.
 * Background tokens are light shades; text tokens are dark shades for WCAG AA contrast.
 */
const AVATAR_COLORS: ReadonlyArray<AvatarColorPair> = [
  { bg: 'positive2', text: 'positive8' }, // green
  { bg: 'brandHumana2', text: 'brandHumana5' }, // rose
  { bg: 'warning2', text: 'warning8' }, // yellow
  { bg: 'brandYellow3', text: 'brandYellow6' }, // orange
  { bg: 'brandBlue2', text: 'brandBlue6' }, // blue
  { bg: 'primary2', text: 'primary8' }, // violet
  { bg: 'info2', text: 'info7' }, // peach
];

/**
 * djb2 hash → index into AVATAR_COLORS.
 * Same string always produces the same index.
 */
export const getAvatarColorIndex = (key: string): number => {
  let hash = 5381;
  for (let i = 0; i < key.length; i++) {
    hash = ((hash << 5) + hash) ^ key.charCodeAt(i);
  }
  return (hash >>> 0) % AVATAR_COLORS.length;
};

export const getAvatarColor = (key: string): AvatarColorPair => {
  return AVATAR_COLORS[getAvatarColorIndex(key)];
};
